import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const JuneSehriIftaar = ({districtDetails}) => {
  return <MonthlyTimeTable month={6} title="June Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default JuneSehriIftaar;
